import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/rockets4.jpg' satisfies MediaPath
const p1 = 'ut/IMG_20201018_064430.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'around',
	name: 'Around',
	excerpt: 'A wandering path',
	tags: ['photography'],
	cover,
	order: 60,
}

export default function Around() {
	return (
		<>
			<p>Closer to home — texture, light, and the spaces between.</p>
			<Gallery
				items={[
					{ src: cover, alt: 'Launch' },
					{ src: p1, alt: 'Backlit' },
				]}
			/>
		</>
	)
}
